// The Perksmith Counter kit — one surface every pack screen builds on.
//
// Import from "@/components/counter". Nothing here is a restaurant part or a hotel part: a dish
// tile, a room tile and a lab-sample tile are the same tile with different words, which is the
// whole reason this file exists. If a screen needs a part that is not here, the part goes here
// first — a component hand-rolled inside a pack is a component the other twenty-three packs will
// draw again, slightly differently, and `npm run check:design` will say so.
//
// The system it renders is DESIGN.md (Basalt & Honey, register B-01/B-02). Every colour, face,
// size, radius, target and duration it uses is declared once in app/globals.css.

// Brand.
export { PerksmithMark, PerksmithWordmark, PerksmithCounterLockup, PerksmithRewardsLockup } from "@/components/brand/perksmith-mark";

// Surfaces and titles.
export { Panel, SectionLabel, ScreenTitle } from "./Panel";

// Actions. There is no other button on a Counter screen.
export { CounterButton, PrimaryAction, type CounterButtonTone, type CounterButtonSize, type CounterButtonProps } from "./Button";

// Money. Every amount on every screen goes through Amount.
export { Amount, type AmountScale } from "./Money";

// The order line and the bill.
export { LedgerLine, LedgerTotal, LedgerSummaryRow, AppliedRow } from "./LedgerRows";

// Boards and grids: the dish, the room, the chair, the bay, the SKU.
export { ItemTile, StatusTile, type ObjectState } from "./Tile";
export { CategoryTabs, type CategoryTab } from "./Tabs";

// Status and marks.
export { Chip, type ChipTone } from "./Chip";
export { KotChip } from "./KotChip";
export { Icon, FssaiMark } from "./Icon";

// Input.
export { Segmented, SearchField, type SegmentedOption } from "./Controls";
export { Keypad, type KeypadKey } from "./Keypad";
export { Field, TextInput, SelectInput, TextArea, NumberStepper, ChipToggle, RadioChips, Switch, ActionButton } from "./Form";

// Overlays. A till interrupts a person mid-transaction, so this is deliberately a small set.
export { Modal, Drawer, ConfirmDialog, ReasonDialog } from "./Overlay";

// Motion: the brand's three moments, K-05 / K-12 / K-13.
export { CounterLoader, TenderOutcome } from "./Motion";

// The three states every contract-backed surface must render, plus the full stop.
export { LoadingBlock, ProblemNote, EmptyNote } from "./States";
export { Blocker, type BlockerKind } from "./Blocker";

// The frame every pack screen mounts into. It lives in components/shell because the rail knows
// about packs and routes, which no other part of the kit does.
export { PosShell, ShellHeader, ShellTitle } from "@/components/shell/PosShell";
export { PosRail, DEFAULT_NAV, type RailItem } from "@/components/shell/PosRail";
